import { Grid, GridItem } from "@project/ui";
import type { ReactNode } from "react";
import { gridGap, gridTemplateColumns } from "@project/ui/src/theme/global-styles";
import { ModuleSpacer } from "../module-spacer";
import { AnimatingWrapper } from "@/components/animating-wrapper";

type HeroFullScreenHeaderComponentProps = {
    overTitleComponent?: ReactNode;
    gridItem1?: ReactNode;
    gridItem2?: ReactNode;
    gridItem3?: ReactNode;
};

export const HeroFullScreenHeaderComponent = (props: HeroFullScreenHeaderComponentProps) => {
    const { overTitleComponent, gridItem1, gridItem2, gridItem3 } = props;

    return (
        <ModuleSpacer pt={{ base: 0, l: 12 }} pb={{ base: 12, l: 16 }}>
            {overTitleComponent && <AnimatingWrapper>{overTitleComponent}</AnimatingWrapper>}
            <Grid templateColumns={gridTemplateColumns} gap={gridGap}>
                <GridItem colStart={{ base: 1, md: 1 }} colEnd={{ base: 3, l: 7 }}>
                    <AnimatingWrapper delay={0.7}>{gridItem1}</AnimatingWrapper>
                </GridItem>
                {gridItem2 && (
                    <GridItem colStart={{ base: 1, l: 7, md: 8 }} colEnd={{ base: 3, l: 10 }}>
                        <AnimatingWrapper delay={0.8}>{gridItem2}</AnimatingWrapper>
                    </GridItem>
                )}
                {gridItem3 && (
                    <GridItem colStart={{ base: 1, l: 10 }} colEnd={{ base: 3, l: 13 }}>
                        <AnimatingWrapper delay={1}>{gridItem3}</AnimatingWrapper>
                    </GridItem>
                )}
            </Grid>
        </ModuleSpacer>
    );
};
